import AppModal from "components/Modal";
// import { loginKeychain } from "helpers/keychain";
// import { loginWithWif } from "helpers/steem";
import React, { 
    useEffect,
    useState,
    //useEffect 
}  from 'react';
import ReactDOM from "react-dom";
// import { useForm } from "react-hook-form";
import { useAuth } from '../../../helpers/authContext';

import {
    Button,
//   Button,
  Card,
  CardBody,
  Col,
  FormGroup, 
} from "reactstrap";
import ImageUploader from "components/ImageUploader";
import { useToast } from "components/ui/use-toast";
import { useForm } from "react-hook-form";
import { isLoggedWithKeychain } from "services/dsteem-service";
import { addToPlaylistWithWif, createPlaylistWithWif, editPlaylistWithWif } from "helpers/steem";
import useModal from "helpers/useModal";
import LoginModal from "./LoginModal";
import { addToPlaylistKeychain, createPlaylistKeychain, editPlaylistKeychain } from "helpers/keychain";  
type Props = {
  isShowing: boolean,
  hide: any, 
  author?:string,
  permlink?:string,
  edit?:boolean,
  editItem?:any,
  onSuccess?: (data: {
    username: string;
    wif?: string;
  }) => void;
}

export const PlaylistsModal = ({ isShowing, hide, author="", permlink="", edit=false, editItem={ name: '', description: '', cover: '', can_remix:'' }}: Props) => {
    const { register, setValue, watch } = useForm<FormData>();
    const { user, metadata, autologin, updateUserMetadata } = useAuth();
    const [playlists, setPlaylists] = useState(metadata?.playlists || []);
    const [menu, setMenu] = useState(edit?2:1);
    const [requiredActive, setRequiredActive] = useState<any>(true);
    const { isOpenLoginModal, toggleLoginModal  } = useModal();
    const { toast } = useToast();
    const [pendingAction, setPendingAction] = useState<null | {
        type: "create" | "edit" | "add";
        payload: any;
    }>(null);

    const [newPlaylist, setNewPlaylist] = useState({ name: '', description: '', cover: '', can_remix:'' });
    const keychainLogin = isLoggedWithKeychain(autologin);
    const createPlaylist = () => {
        setPlaylists([]);
    }
    
    useEffect(()=> { 
        updateUserMetadata();
    },[isShowing]);
    useEffect(()=> {
        setPlaylists(metadata?.playlists || []);
    },[metadata]);
    useEffect(() => {
        if (edit && editItem?.id) {
            setNewPlaylist({
            name: editItem?.name || "",
            description: editItem?.description || "",
            cover: editItem?.cover || "",
            can_remix: editItem?.can_remix || ""
            });
        }
    }, [edit, editItem, isShowing]);

    function generatePlaylistId(username: string) {
        const random = Math.floor(100000 + Math.random() * 900000);  
        return `${username}-${random}`;
    }
    function getSteemDate() {
        const d = new Date();

        const pad = (n: number) => String(n).padStart(2, "0");

        return `${d.getUTCFullYear()}-` +
                `${pad(d.getUTCMonth() + 1)}-` +
                `${pad(d.getUTCDate())}T` +
                `${pad(d.getUTCHours())}:` +
                `${pad(d.getUTCMinutes())}:` +
                `${pad(d.getUTCSeconds())}`;
    } 
    const handleCreatePlaylist = async (newWif = "") => { 
        if (newPlaylist?.name) {
            const fn = keychainLogin ? createPlaylistKeychain : createPlaylistWithWif;
            const account = keychainLogin ? user : autologin;
            const playlistWithId = {
                ...newPlaylist,
                id: generatePlaylistId(user),
                created_at: getSteemDate()
            };
            let res:any = await fn(account, playlistWithId, newWif);
            if (!res.success) {
                if(res.message.toString().includes("Missing Active Authority")){
                    setPendingAction({
                        type: "create",
                        payload: playlistWithId
                    });
                    setRequiredActive(true);
                    toggleLoginModal();
                    return;
                }
                
                toast({
                title:"Failed creating playlist.",
                description:res.message,
                variant:"rose_red"
                });
            }else {
                toast({
                title:"Playlist created successfully.",
                description:"Your changes may take a few minutes to take effect.",
                variant:"wild_green"
                });
                setNewPlaylist({ name: '', description: '', cover: '', can_remix:'' });
                updateUserMetadata();
                setMenu(1);
            }
        }else{
            toast({
                title:"Failed creating playlist.",
                description:"Name is required.",
                variant:"rose_red"
            });
        }
        
    } 
    const handleAddToPlaylist = async (playlistId, author, permlink, newWif = "") => { 
        if (playlistId) {
            const fn = keychainLogin ? addToPlaylistKeychain : addToPlaylistWithWif;
            const account = keychainLogin ? user : autologin; 
            let res:any = await fn(account, playlistId, {author, permlink},newWif);
            if (!res.success) {
                if(res.message.toString().includes("Missing Active Authority")){
                    setPendingAction({
                        type: "add",
                        payload: { playlistId, author, permlink }
                    });
                    setRequiredActive(true);
                    toggleLoginModal();
                    return;
                }
                
                toast({
                title:"Failed adding to playlist.",
                description:res.message,
                variant:"rose_red"
                });
            }else {
                toast({
                title:"Item created successfully.",
                description:"Your changes may take a few minutes to take effect.",
                variant:"wild_green"
                }); 
                updateUserMetadata(); 
            }
        }else{
            toast({
                title:"Failed adding item to playlist.",
                description:"ID is required.",
                variant:"rose_red"
            });
        }
        
    } 
    const handleEditPlaylist = async (newWif = "") => { 
        if (editItem?.id) {
            const fn = keychainLogin ? editPlaylistKeychain : editPlaylistWithWif;
            const account = keychainLogin ? user : autologin;
            const playlistWithId = { 
                id:editItem?.id,
                ...editItem,
                ...newPlaylist, 
                edited_at: getSteemDate()
            };
            let res:any = await fn(account, playlistWithId, newWif);
            if (!res.success) {
                if(res.message.toString().includes("Missing Active Authority")){
                    setPendingAction({
                        type: "edit",
                        payload: playlistWithId
                    });
                    setRequiredActive(true);
                    toggleLoginModal();
                    return;
                }
                
                toast({
                title:"Failed editing playlist.",
                description:res.message,
                variant:"rose_red"
                });
            }else {
                toast({
                title:"Playlist edited successfully.",
                description:"Your changes may take a few minutes to take effect.",
                variant:"wild_green"
                });
                // setNewPlaylist({ name: '', description: '', cover: '', can_remix:'' });
                updateUserMetadata();
                hide();
            }
        }else{
            toast({
                title:"Failed editing playlist.",
                description:"ID is required.",
                variant:"rose_red"
            });
        }
        
    } 
    const renderForm = (
        <div className="modal-body post-editor-body p-0">
        <Card className="no-shadow border-0 h-100">
            {user && (
                <CardBody className="px-lg-3 py-0 body-gray h-100">
                    <div className="post-editor-wrapper">
                        <div className="post-editor-scroll-area px-3">
                            {menu == 1 && (
                                <>
                                    {/* <p>You are going to add this post <code>{author}/{permlink}</code></p> */}
                                    <ul className="playlists">
                                        <li onClick={() => setMenu(2)}><i className="fas fa-plus" /> Create a new playlist.</li>
                                        {playlists.map((playlist,i) => { 
                                            let items = playlist?.items?.length || 0;
                                            const isInPlaylist = playlist?.items?.some(
                                                (item) => item.author === author && item.permlink === permlink
                                            );
                                            return (
                                                <li key={playlist?.id || i} className="playlist-item" onClick={() => {
                                                    handleAddToPlaylist(playlist?.id, author, permlink);
                                                }}>
                                                    <span className="playlist-left">
                                                    {playlist?.cover ? (
                                                        <img src={playlist.cover} />
                                                    ) : (
                                                        <i className="fas fa-list" />
                                                    )}

                                                    <span className="playlist-info">
                                                        <span className="playlist-name">{playlist?.name}</span>
                                                        <span className="playlist-count">
                                                            {items} {items === 1 ? "video" : "videos"}
                                                        </span> 
                                                    </span>
                                                    </span>

                                                    <i className={`${isInPlaylist ? "fas color-speem" : "far"} fa-bookmark playlist-bookmark`} />
                                                </li>
                                            );   
                                        })}
                                    </ul> 
                                    {playlists.length == 0 && (
                                        <p><b>You don't have playlists yet. <a href="" onClick={createPlaylist}>Create a new one and start saving your favorite videos.</a></b></p>
                                    )}
                                </>
                            )}
                            {menu == 2 && (
                                <Col md="12" className="mt-3">
                                    <p className="promotion-description fw-bold">{!edit ?"Create a new":"Edit"} playlist</p>
                                    <FormGroup>
                                        <div className="input-icon-group">
                                            <i className="fas fa-list input-icon" />
                                            <input className="form-control fancy-input" name="name" placeholder="Playlist Name" defaultValue={editItem?.name || ""} onChange={(e) => setNewPlaylist({ ...newPlaylist, name: e.target.value })} />
                                        </div>
                                    </FormGroup> 
                                    <FormGroup> 
                                        <textarea className="form-control fancy-input description-input" name="description" placeholder="Description (Optional)" defaultValue={editItem?.description || ""} onChange={(e) => setNewPlaylist({ ...newPlaylist, description: e.target.value })} style={{ minHeight: '80px', paddingTop: '10px', paddingLeft: '45px' }} />
                                    </FormGroup> 
                                    <ImageUploader 
                                        inputName="cover_image" 
                                        placeholder='Cover image'
                                        defaultValue={newPlaylist.cover || editItem?.cover || ""}
                                        register={register}
                                        setErrorMessage={(err)=> toast({title:"OPs something failed",description:err, variant:"rose_red"})}
                                        onUpload={(url) => { 
                                            setNewPlaylist({ ...newPlaylist, cover: url })
                                        }}
                                        watch={watch}
                                        setValue={setValue}
                                    /> 
                                </Col>
                            )}
                        </div>
                        {menu == 2 && (
                            <div className="post-editor-buttons px-3">
                                {!edit && <Button color="secondary" onClick={() => setMenu(1)}><i className="fas fa-chevron-left" /> Back</Button>}
                                {!edit && (
                                    <Button color="default" onClick={() => handleCreatePlaylist()}>
                                        {keychainLogin ? <>Create with <img className="icon icon-sm ml-1" src="/assets/img/keychain.svg" /></> : "Create"}
                                    </Button>
                                )}
                                {edit && (
                                    <Button color="default" onClick={() => handleEditPlaylist()}>
                                        {keychainLogin ? <>Save changes with <img className="icon icon-sm ml-1" src="/assets/img/keychain.svg" /></> : "Save changes"}
                                    </Button>
                                )}
                            </div>
                        )}
                    </div>
                </CardBody>
            )}
            {!user && (<p className="p-3">Please log in to see your playlists.</p>)}
        </Card>
        </div>
    );

  return (
    isShowing ? ReactDOM.createPortal(
      <React.Fragment>
        <AppModal
          isShowing={isShowing}
          hide={hide}
          size="md"
          header="Playlists"
          children={renderForm}
        />
        <LoginModal
            isShowing={isOpenLoginModal}
            hide={toggleLoginModal}
            requiredActive={requiredActive}
            onSuccess={({ wif }) => {
                // if (wif) {
                // handleCreatePlaylist(wif);
                // }
                if (!wif || !pendingAction) return;

                if (pendingAction.type === "create") {
                handleCreatePlaylist(wif);
                }
                if (pendingAction.type === "edit") {
                handleEditPlaylist(wif);
                }

                if (pendingAction.type === "add") {
                const { playlistId, author, permlink } = pendingAction.payload;
                handleAddToPlaylist(playlistId, author, permlink, wif);
                }

                setPendingAction(null); 
            }}
            />
      </React.Fragment>, document.body
    ) : null)
};

export default PlaylistsModal;